export default "__VITE_ASSET__JQSpMMtP__"